import { createRouter, createWebHistory } from 'vue-router';
import HomePage from '@/views/HomePage.vue';
import ResultsPage from '@/views/ResultsPage.vue';
import HelpPage from '@/views/HelpPage.vue';
import BatchPage from '@/views/BatchPage.vue';
import AboutPage from '@/views/AboutPage.vue';
import QueryPage from '@/views/QueryPage.vue';
import axios from 'axios';
import API_BASE_URL from '@/api';

const routes = [
  { path: '/home', name: 'HomeEntry' },
  { path: '/home/:taskId', name: 'HomeTask', component: HomePage, props: true },

  { path: '/batch', name: 'BatchEntry' },
  { path: '/batch/:taskId', name: 'BatchTask', component: BatchPage, props: true },

  // ✅ Query：只保留带 taskId 的形式（用户自定义，不校验）
  { path: '/query/:taskId', name: 'QueryTask', component: QueryPage, props: true },

  // 静态页
  { path: '/results', name: 'Results', component: ResultsPage },
  { path: '/help', name: 'Help', component: HelpPage },
  { path: '/about', name: 'About', component: AboutPage },

  // 根路径
  { path: '/', redirect: '/home' },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

/**
 * 规则说明：
 * - Home / Batch：
 *   - /home、/batch  → 自动创建 taskId
 *   - /home/:taskId、/batch/:taskId → 必须 validate
 *
 * - Query：
 *   - /query/:taskId → 不校验，直接放行（用户自定义）
 */

const ENTRY = new Set(['HomeEntry', 'BatchEntry']);
const NEED_VALIDATE = new Set(['HomeTask', 'BatchTask']);

router.beforeEach(async (to, from, next) => {
  // 静态页 & Query 直接放行
  if (!ENTRY.has(to.name) && !NEED_VALIDATE.has(to.name)) {
    return next();
  }

  // 防止无限循环
  if (to.meta.__fixed_once) return next();

  try {
    // /home /batch：创建 taskId
    if (ENTRY.has(to.name)) {
      const { data } = await axios.post(
        `${API_BASE_URL}/api/biology/create_task/`,
        null,
        { withCredentials: true }
      );

      const taskId = data.task_id;

      return next({
        name: to.name === 'HomeEntry' ? 'HomeTask' : 'BatchTask',
        params: { taskId },
        replace: true,
      });
    }

    // /home/:taskId /batch/:taskId：校验
    const taskId = to.params.taskId;
    const v = await axios.get(
      `${API_BASE_URL}/api/biology/validate_task/${taskId}/`,
      { withCredentials: true }
    );

    if (v.data.valid) return next();

    // 不合法 → 只重建一次
    const { data } = await axios.post(
      `${API_BASE_URL}/api/biology/create_task/`,
      null,
      { withCredentials: true }
    );

    return next({
      name: to.name,
      params: { taskId: data.task_id },
      replace: true,
      meta: { ...to.meta, __fixed_once: true },
    });
  } catch (e) {
    console.error(e);
    return next(false);
  }
});

export default router;

